module.exports = __webpack_public_path__ + "img/yurt-img-1.65a11183.jpg";